import styled from '@emotion/styled';
import { css } from '@emotion/core';
import ButtonBaseUnstyled from '../ButtonBase/ButtonBase';
import theme from '../../themes/default';
import styleUtils from '../../styles/utils';
import createSharedStyles from './IconButton.shared.style';

const sharedStyles = createSharedStyles(css, theme, styleUtils);

const container = css`
  padding: 0;
  min-width: auto;
`;

export default {
  container: {
    base: container,
    bySize: (caret) => sharedStyles.buttonSizes(caret),
  },
  content: {
    bySize: sharedStyles.iconSizes,
  },
  loader: {
    bySize: sharedStyles.loaderSizes,
  },
};

export const loaderSizes = { ...sharedStyles.loaderSizes };

export const ButtonBase = styled(ButtonBaseUnstyled)`
  padding: 0;
  min-width: auto;
  ${(props) => sharedStyles.buttonSizes(props.caret)[props.size]};
`;

export const ButtonCaret = styled.span`
  margin-top: 8px;
  margin-left: -4px;
`;

export const IconComponent = (icon) => styled(icon)`
  ${(props) => sharedStyles.iconSizes[props.size]};
`;
